<template>
    <div>
        <h3 class="mx-3 mb-3 text-2xl font-semibold">
            Detalle de rol
            <span class="text-theme-primary">
                {{ role.slug }}
            </span>
        </h3>
        <div id="general" class="flex flex-wrap">
            <div class="w-full md:w-1/2 mt-6 px-2">
                <text-component label="Nombre" :value="role.name" />
            </div>
            <div class="w-full md:w-1/2 mt-6 px-2">
                <text-component label="Slug" :value="role.slug" />
            </div>

            <text-component
                class="w-full mt-8"
                label="Descripción"
                :value="role.description"
            />
        </div>
        <div v-if="role.permissions.length" class="flex flex-wrap">
            <h4 class="mt-4 ml-4">Permisos de rol "{{ role.name }}"</h4>
            <div class="w-full flex justify-center">
                <permissions-table
                    :items="role.permissions"
                    :show-role="false"
                />
            </div>
        </div>
    </div>
</template>

<script>
import PermissionsTable from "@/components/permissions/PermissionsTable.vue";
import TextComponent from "@/components/utils/TextComponent.vue";

export default {
    name: "RoleView",
    components: {
        PermissionsTable,
        TextComponent
    },
    props: {
        role: {
            type: Object,
            default: () => ({
                id: 2,
                slug: "",
                name: "",
                description: "",
                permissions: [
                    {
                        id: 0,
                        name: "",
                        slug: ""
                    }
                ]
            }),
            required: true
        }
    }
};
</script>
